export const FORM_STATUS = {
    INITIAL   : 0,
    VALIDATED : 1,
    SENDING   : 2,
    SUCCESS   : 3,
    ERROR     : 4
}